document.addEventListener("DOMContentLoaded", function () {
  const variantsEl = document.querySelector("[data-variants]");
  const badgesEl = document.querySelector("[data-badges]");

  if (!variantsEl || !badgesEl) return;

  let variants = [];
  let subscriptionBadgeMap = {};
  let oneTimeBadgeMap = {};

  try {
    variants = JSON.parse(variantsEl.textContent).variants || [];
  } catch (err) {
    console.error("Could not parse [data-variants] JSON", err);
    return;
  }

  try {
    const badgeData = JSON.parse(badgesEl.textContent) || {};
    subscriptionBadgeMap = badgeData.subscriptionBadges || {};
    oneTimeBadgeMap = badgeData.oneTimeBadges || {};
  } catch (err) {
    console.error("Could not parse [data-badges] JSON", err);
    return;
  }

  if (!variants.length) return;

  function getSelectedPlanType() {
    const checkedPlan = document.querySelector(".rc-radio__input:checked");

    if (checkedPlan && checkedPlan.value) {
      return checkedPlan.value;
    }

    return "subsave";
  }

  function getActiveBadgeMap() {
    const selectedPlanType = getSelectedPlanType();

    return selectedPlanType === "onetime"
      ? oneTimeBadgeMap
      : subscriptionBadgeMap;
  }

  function getOptionNamesInOrder() {
    const names = [];

    document.querySelectorAll(".product-option__radio").forEach((radio) => {
      if (!names.includes(radio.name)) names.push(radio.name);
    });

    return names;
  }

  function getSelectedOptions(optionNames) {
    return optionNames.map((name) => {
      const checked = document.querySelector(
        `.product-option__radio[name="${CSS.escape(name)}"]:checked`
      );

      return checked ? checked.value : null;
    });
  }

  function updateBadges() {
    const allRadios = Array.from(
      document.querySelectorAll(".product-option__radio")
    );

    if (!allRadios.length) return;

    const badgeMap = getActiveBadgeMap();
    const optionNames = getOptionNamesInOrder();
    const selectedOptions = getSelectedOptions(optionNames);

    allRadios.forEach((radio) => {
      const label = document.querySelector(
        `label[for="${CSS.escape(radio.id)}"]`
      );

      if (!label) return;

      const badgeEl = label.querySelector(".variant-value");

      if (!badgeEl) return;

      const optionPosition = optionNames.indexOf(radio.name);

      if (optionPosition === -1) {
        badgeEl.textContent = "";
        return;
      }

      const candidateOptions = selectedOptions.slice();
      candidateOptions[optionPosition] = radio.value;

      const matched = variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== candidateOptions.length) return false;

        return variant.options.every((opt, i) => opt === candidateOptions[i]);
      });

      badgeEl.textContent = matched ? badgeMap[String(matched.id)] || "" : "";
    });
  }

  updateBadges();

  document.addEventListener("change", function (event) {
    if (
      event.target &&
      (
        event.target.matches(".product-option__radio") ||
        event.target.matches(".rc-radio__input") ||
        event.target.matches("#selling_plan")
      )
    ) {
      /**
       * Small delay allows Alpine / Recharge widget state to update first.
       */
      setTimeout(updateBadges, 0);
    }
  });
});